import React from "react"
import { Cursor } from "../../elements"
import styled from "styled-components"

const SelectedCursor = ({ xValue, yValue }) => {
  return (
    <Selected
      top={yValue}
      left={xValue}
      height="35"
      width="35"
      posTop="0"
      posLeft="0"
      zIndex="99999999999"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201.32 230.19">
        <title>sdg-banana-peeled</title>
        <g className="cls-1">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path
                className="cls-2"
                d="M79.29,58.17C74,55.82,29.88,65.53,46.06,126.26c.88,3.31,5.82,2.57,5.83-.85C52,105,56.16,75.17,80.48,77"
              />
              <path d="M48.83,132.4a6.83,6.83,0,0,1-6.64-5.11c-9.59-36,1.25-54.58,12-63.82,9.88-8.47,22.2-10.93,26.68-9l-3.21,7.32a.84.84,0,0,0,.21.08c-2.22-.51-12.67,1.44-20.75,9.77-9.78,10.09-12.85,25.81-9,45.74,1.32-22.3,7.77-33,13.26-38,5.19-4.79,11.71-6.93,19.4-6.34l-.61,8c-5.45-.42-9.82,1-13.36,4.24C59.84,91.71,56,106,55.89,125.42a7,7,0,0,1-6.14,6.92A7.22,7.22,0,0,1,48.83,132.4Z" />
              <path
                className="cls-3"
                d="M201.29,36.16C198.49,15,180.37,8.64,178.38,8,175.45,6.89,142.14-4.78,119,29.16l3.22,2.2,17,13.46c-.23,1.64-.28,2.64-.28,2.7l7.79.32a40.22,40.22,0,0,1,6.7-19.55c11.12-5.1,33.9,6.63,41.89,11.68a3.82,3.82,0,0,0,2.08.61,3.91,3.91,0,0,0,3.87-4.42Z"
              />
              <path d="M132.09,208.64l-3.66,12.19a11.75,11.75,0,0,1-7.82,7.86l-3.16,1a11.78,11.78,0,0,1-13-4.3h0a11.78,11.78,0,0,1-.89-12.51l4.88-9.15Z" />
              <g className="cls-4">
                <path
                  className="cls-2"
                  d="M131,42.56S132.5,8.8,165.35,6.64c0,0-32.26-13.53-54.91,19.55"
                />
                <path d="M135,42.73l-8-.35c0-.29,1.29-23.61,19.78-34.44-9.94.67-22.56,5.16-33.06,20.51l-6.61-4.51c24.21-35.37,59.4-21.13,59.76-21a4,4,0,0,1-1.29,7.68C136.67,12.54,135.07,41.5,135,42.73Z" />
              </g>
              <g className="cls-4">
                <path
                  className="cls-2"
                  d="M165.35,6.64s17.7,5.36,20.27,25c0,0-31.11-19.81-46.42-11.63"
                />
                <path d="M185.62,35.68a4,4,0,0,1-2.15-.63,118.32,118.32,0,0,0-16.93-8.59c-11.49-4.65-20.29-5.64-25.45-2.89l-3.77-7c7.44-4,18.32-3.12,32.33,2.57,3.42,1.38,6.6,2.89,9.31,4.27a27.32,27.32,0,0,0-14.77-12.89l2.32-7.65c.82.25,20.21,6.36,23.07,28.34a4,4,0,0,1-4,4.52Z" />
              </g>
              <path
                className="cls-2"
                d="M112.61,204.23,117,193.89a8,8,0,0,0,.37-1.16c11.58-46.13,6.77-81.89-14.69-109.29C84.39,60.1,53.79,43.07,9.13,31.4a17.91,17.91,0,0,1-4.55-3.06,3.33,3.33,0,0,1,.34-4.17l.37-.38a8.16,8.16,0,0,1,2.94-2,3.73,3.73,0,0,0,.69-.35L10.66,21A141,141,0,0,1,51.21,15c41.72,0,81.24,18.78,100.68,47.83,16.51,24.69,20.77,51.7,12.65,80.29A134.1,134.1,0,0,1,139,191a62.6,62.6,0,0,0-6.25,8.73l-5,8.5Z"
              />
              <path d="M51.21,19c40.42,0,78.64,18.08,97.35,46.06,15.84,23.66,19.92,49.56,12.14,77a129.81,129.81,0,0,1-24.78,46.36,67.13,67.13,0,0,0-6.64,9.29l-3.49,5.9-7.7-2,2.57-6.1a11,11,0,0,0,.57-1.73c6-23.88,7.63-45.56,4.88-64.44A100.65,100.65,0,0,0,105.81,81C87,57,55.88,39.54,10.58,27.64a23.23,23.23,0,0,1-2.18-1.3,4.35,4.35,0,0,1,1.3-.79,8.84,8.84,0,0,0,.83-.38l.68-.21.4-.12.12,0,.08,0A137.29,137.29,0,0,1,51.21,19m0-8a145.33,145.33,0,0,0-41.7,6.12h0l-.21.07c-.58.18-1.17.35-1.75.54a2.91,2.91,0,0,0-.79.39A12.15,12.15,0,0,0,2.4,21L2,21.4a7.3,7.3,0,0,0-.75,9.2c1.49,2.18,6.39,4.56,6.47,4.58C87.82,56,137.14,97.42,113.47,191.76a3.45,3.45,0,0,1-.18.57l-4.81,11.38a3,3,0,0,0,2,4.1l16.89,4.47a3,3,0,0,0,.78.1,3,3,0,0,0,2.59-1.48l5.42-9.15a57.74,57.74,0,0,1,5.84-8.16c12.45-14.59,53.5-72.75,13.2-133C135.46,31.08,95.31,11,51.21,11Z" />
              <path d="M122.92,208.72l-7.14-3.6C144.12,149,143.3,104.31,113.33,72.19l5.85-5.46A91.39,91.39,0,0,1,144,123.11C146,148.27,138.91,177.07,122.92,208.72Z" />
              <path
                className="cls-2"
                d="M116.26,69.46S157,24.66,181.71,89.84c1.39,3.66,5.32,2.29,6.54-1.42C197.5,60.27,161,16.92,126.3,38.68,106.47,51.12,121.18,71.6,116.26,69.46Z"
              />
              <path d="M184.33,96A6.85,6.85,0,0,1,178,91.26c-7.35-19.41-16.68-30.32-27.71-32.43-12.49-2.4-24.48,7.15-29.08,11.39a4.23,4.23,0,0,1-1.49,2.38,4.67,4.67,0,0,1-5,.53l-5.12-2.23L113,67.12c0-.1,0-.2-.07-.29-1.46-6.41-4.9-21.4,11.26-31.53,15.61-9.8,33.28-8.59,48.48,3.31,16.41,12.84,24.74,34.79,19.4,51.06-1.22,3.7-4.26,6.24-7.58,6.32ZM146.18,50.44a29.42,29.42,0,0,1,5.55.52c13.53,2.57,24.61,14.5,33,35.46,3.84-13.15-3.33-30.85-17-41.51-12.39-9.7-26.71-10.73-39.3-2.84-8.95,5.62-9.42,13-8.55,18.76C125.86,56.16,135.4,50.44,146.18,50.44Z" />
              <path
                className="cls-2"
                d="M116.26,69.46s-53.37-16.24-40.82,58.4,11.86-58.07,40.82-58.4"
              />
              <path d="M82.28,154.63h-.14c-4.93-.1-7.22-5.71-10.65-26.11C66.88,101.08,70.42,82,82,71.81c14.17-12.45,34.55-6.44,35.41-6.18l2.51,4.05-3.62,3.78C105,73.59,97.51,109,93.52,128,89.47,147.32,87.93,154.63,82.28,154.63ZM104.11,72c-5.39.1-11.79,1.4-16.86,5.87C78,86,75.32,103.05,79.38,127.19c1.16,6.88,2.12,11.44,2.88,14.46,1.12-4.29,2.36-10.16,3.43-15.28C89.86,106.53,94.77,83.13,104.11,72Z" />
              <g className="cls-4">
                <path
                  className="cls-3"
                  d="M134.3,40.68c-12.63,7.93-11.25,19.1-9.85,25.62a38.52,38.52,0,0,0-4.52,3.38c-7.08-2.51-21.27-5.83-30.43,3.44l-1.21,3L81.16,64.09C80.8,59.69,35.77,73.5,52,134.23c.88,3.31,5.81,2.58,5.83-.85C57.85,113,62.05,83.14,86.37,85c-4.63,9-6.61,23-2.93,44.86,10,59.28,14.56-11.54,29.32-43.65-.06.22,36.9,44,6.39,117.5l14.94,4.93S211,150.83,161.37,58.09c0,0,13.46-5.5,28.34,33.75,1.39,3.66,5.32,2.29,6.54-1.42C205.5,62.27,169,18.92,134.3,40.68Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Selected>
  )
}

export default SelectedCursor

const Selected = styled(Cursor)`
  .cls-1 {
    isolation: isolate;
  }
  .cls-2 {
    fill: #fff;
  }
  .cls-3 {
    fill: #edd375;
  }
  .cls-4 {
    mix-blend-mode: multiply;
  }
`
